import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { Typography } from "@mui/material";

interface Address {
  city?: string;
}

interface Home {
  address?: Address;
  communityName?: string;
  builderName?: string;
}

interface OrderCardHomeFieldProps {
  home?: Home | null;
}

export const OrderCardHomeField = memo<OrderCardHomeFieldProps>(({ home }) => {
  const { classes } = useStyles();

  return (
    <Typography className={classes.homeText}>
      {home
        ? `${home?.address?.city || ""} | ${home?.communityName || ""} | ${
            home?.builderName || ""
          }`
        : ""}
    </Typography>
  );
});

OrderCardHomeField.displayName = "OrderCardHomeField";

const useStyles = makeStyles()((theme) => ({
  homeText: {
    fontSize: "0.75rem",
    minWidth: 180,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    color: theme.palette.grey.main,
  },
}));
